import { APICore } from './apiCore'

const api = new APICore()

function getTiposSolicitantes (params) {
  const baseUrl = '/tipos-solicitante'
  return api.get(baseUrl, params)
}

function getTipoSolicitante (id) {
  const baseUrl = `/tipos-solicitante/${id}`
  return api.get(baseUrl, {})
}

function addTiposSolicitante (params) {
  const baseUrl = '/tipos-solicitante'
  return api.create(baseUrl, params)
}

function updateTiposSolicitante (params) {
  const baseUrl = '/tipos-solicitante'
  return api.update(baseUrl, params)
}

function updateOrderTiposSolicitante (params) {
  const baseUrl = '/tipos-solicitante/order'
  return api.update(baseUrl, params)
}

function deleteTiposSolicitante (params) {
  const baseUrl = '/tipos-solicitante'
  return api.delete(baseUrl, params)
}

export { getTiposSolicitantes, getTipoSolicitante, addTiposSolicitante, updateTiposSolicitante, updateOrderTiposSolicitante, deleteTiposSolicitante }
